module.exports = __webpack_public_path__ + "static/salon-cc4db471d8bbdebf1d61412f8ff41d53.jpg";